import React from "react";
import { Modal, Button } from "react-bootstrap";
import { weekDays } from "../../utils";

const InvitationConfirmationModal = ({
  show,
  onConfirm,
  onCancel,
  booking,
}) => {
  // Generate readable recurrence days for weekly bookings using weekDays
  const recurrenceDaysText =
    booking?.isRecurring &&
    booking?.recurrenceType === "weekly" &&
    booking?.recurrenceDays?.length > 0
      ? `on ${booking.recurrenceDays
          .map(
            (dayId) => weekDays.find((wd) => wd.id === parseInt(dayId))?.name
          )
          .filter(Boolean)
          .sort(
            (a, b) =>
              weekDays.findIndex((wd) => wd.name === a) -
              weekDays.findIndex((wd) => wd.name === b)
          )
          .join(", ")}`
      : "";

  // Generate Google Calendar event URL with GMT+7 timezone
  const formatGoogleDateTime = (dateStr, timeStr) => {
    const [year, month, day] = dateStr.split("-");
    const [hours, minutes] = timeStr.split(":");
    const localDate = new Date(Date.UTC(year, month - 1, day, hours, minutes));
    // Adjust to GMT+7 by subtracting 7 hours to convert to UTC
    localDate.setHours(localDate.getHours() - 7);
    const isoString = localDate
      .toISOString()
      .replace(/[-:.]/g, "")
      .slice(0, 15);
    return `${isoString}Z`;
  };

  const generateGoogleCalendarUrl = () => {
    if (!booking) return "#";

    const startDateTime = formatGoogleDateTime(booking.date, booking.startTime);
    const endDateTime = formatGoogleDateTime(booking.date, booking.endTime);
    const details = encodeURIComponent(
      `Purpose: ${booking.purpose}\nBooked by: ${booking.name}`
    );
    const location = encodeURIComponent(booking.room.name);
    const title = encodeURIComponent(`Room Booking - ${booking.room.name}`);

    let url = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${startDateTime}/${endDateTime}&details=${details}&location=${location}`;

    if (
      booking.isRecurring &&
      booking.recurrenceType &&
      booking.recurrenceEndDate
    ) {
      const untilDate = formatGoogleDateTime(
        booking.recurrenceEndDate,
        "23:59"
      ).replace(/T235900Z$/, "");
      let rrule = `RRULE:FREQ=${booking.recurrenceType.toUpperCase()};UNTIL=${untilDate}`;

      if (
        booking.recurrenceType === "weekly" &&
        booking.recurrenceDays.length > 0
      ) {
        const dayMap = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];
        const byDay = booking.recurrenceDays
          .map((dayId) => dayMap[parseInt(dayId)])
          .join(",");
        rrule += `;BYDAY=${byDay}`;
      }

      url += `&recur=${encodeURIComponent(rrule)}`;
    }

    return url;
  };

  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add the Calendar Event</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Would you like to add the booking of {booking?.room.name}{" "}
        {booking?.isRecurring
          ? `recurring ${booking?.recurrenceType} ${
              recurrenceDaysText || ""
            } from ${booking?.date} to ${booking?.recurrenceEndDate}`
          : `on ${booking?.date} from ${booking?.startTime} to ${booking?.endTime}`}{" "}
        to your calendar?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="primary"
          href={generateGoogleCalendarUrl()}
          target="_blank"
          rel="noopener noreferrer"
        >
          Add to Google Calendar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InvitationConfirmationModal;
